/* DOMNO. portal — the ladder, and pointing the picker at the right collection.

   Copy is governed by Outputs/Rewards Portal/rewards-copy-deck.md.
   Banned everywhere: unlock, redeem, points, tier, member, VIP, exclusive, claim, loyalty.
   The four steps are pictures and words on a ladder and are NEVER called tiers out loud.

   THE RULE, as of 14 Sep 2026. There is no welcome piece. Order 1 earns a piece, order 2 spends
   it, and THE RUNG IS DECIDED BY ORDER COUNT: order 2 is a ring, 3 a chain, 4 a pendant, 5 is
   anything, then it starts again at a ring. Charlie, relaying Dom.

   ⚠ IT USED TO RUN ON REDEMPTIONS (`had = state.redeemed; now = had % 4`) and this file worked
   the maths out for itself. That duplication was a bug waiting to happen — the worker and this
   file could disagree about which rung someone was on, and the picker follows this file while the
   copy follows the worker. The worker is now the only place the maths lives: it returns `orders`,
   `step` (1-based) and `free_choice`, and this file draws what it is told. Do not reintroduce a
   local calculation, even a "harmless" one.

   ⚠ BIRTHDAY AND REFERRAL PIECES ARE OFF THE LADDER. They are free choice from all four
   collections and they never move the rung (Charlie, 14 Sep). The worker spends them FIRST and
   sets `free_choice` while any are left, so this file simply points the picker at everything
   whenever that flag is true. Do not try to work out the pot on this side — the worker knows
   which one it is about to spend and this file does not.

   ⚠ THE COLLECTIONS ARE THE 7-PIECE BUNDLE'S OWN. Dom, 10 Sep: "use same collections that we use
   for the 7pc bundle" — bundle-rings, chain-bundle, pendant-bundle, bracelet-bundle. They are
   emitted as Liquid from snippets/domno-portal-loginurl.liquid, NOT fetched from
   /collections/x/products.json, because that endpoint answers in shop currency and DOMNO. sets
   foreign prices per product — in USD a £16 chain and a £20 chain are both $35. Liquid's
   `product.price | money` is the only source that is right in every market.

   ⚠ NEVER WRITE data-rings DIRECTLY. Go through window.dpSetRings so the array and the attribute
   are written together — claim.js looks the choice up by INDEX from the attribute, so a mismatch
   hands the customer a different product from the one they tapped.

   Owns: the .ladder strip in #p-rewards, and which dataset the picker holds.
   Does not touch THE ONE BOX (credits.js) or the CTA labels (gift.js). */
(function(){
  var API = 'https://rewards.domno.com';

  /* step -> [dataset key, what to call it, plural for the picker subtitle] */
  var STEPS = [
    { key: 'rings',     one: 'ring',    many: 'rings'    },
    { key: 'chains',    one: 'chain',   many: 'chains'   },
    { key: 'pendants',  one: 'pendant', many: 'pendants' },
    { key: 'any',       one: 'piece',   many: 'pieces'   }
  ];
  var FREE = { key: 'any', one: 'piece', many: 'pieces' };
  var LADDER = ['Ring', 'Chain', 'Pendant', 'Any piece'];

  function customerId(){
    try{
      if (window.DP_CUSTOMER && window.DP_CUSTOMER.id) return String(window.DP_CUSTOMER.id);
      if (window.__st && window.__st.cid) return String(window.__st.cid);
    }catch(e){}
    return '';
  }

  var sets = null;
  function datasets(){
    if (sets) return sets;
    var el = document.getElementById('dp-ladder');
    if (!el) return null;
    sets = {};
    STEPS.forEach(function(s){
      try{ sets[s.key] = JSON.parse(el.getAttribute('data-' + s.key) || '[]'); }
      catch(e){ sets[s.key] = []; }
    });
    return sets;
  }

  var state = null;   /* the whole /api/credits body: balance, orders, step, free_choice, redeemed */

  function freeChoice(){ return !!(state && state.free_choice); }

  /* Which rung their next piece sits on, 0-based, straight from the worker's 1-based `step`.
     Falls back to rung one rather than guessing — a wrong rung shows the wrong products. */
  function step(){
    if (!state) return 0;
    var s = Number(state.step);
    if (!s || s < 1 || s > STEPS.length) return 0;
    return s - 1;
  }

  /* What the picker is about to show. Free choice wins over the rung, because a birthday or
     referral piece is spent before any order one. */
  function activeSet(){ return freeChoice() ? FREE : STEPS[step()]; }

  /* ---------- point the picker at the right collection ---------- */
  function pointPicker(){
    var d = datasets();
    if (!d) return false;
    var s = activeSet();
    var arr = d[s.key];
    /* a step with nothing available in it would leave an empty grid, which reads as broken.
       Fall back to everything rather than showing a customer a blank screen. */
    if ((!arr || !arr.length) && d.any && d.any.length) arr = d.any;
    if (!arr || !arr.length) return false;
    if (typeof window.dpSetRings !== 'function') return false;
    return window.dpSetRings(arr);
  }

  /* the picker's own title and count, which gift.js also writes — it sets "Choose your free
     <noun>" from dpRewardNoun(), so both agree. */
  function titlePicker(){
    var s = activeSet();
    var d = datasets();
    var n = d && d[s.key] ? d[s.key].length : 0;
    if ((!n) && d && d.any) n = d.any.length;
    var sub = document.querySelector('#dp-pickerVeil .pickhead .ps');
    if (sub && n) sub.textContent = n + ' ' + s.many + ' to pick from';
  }

  /* ---------- the ladder strip ---------- */
  function paintLadder(){
    var strip = document.querySelector('#p-rewards .ladder');
    if (!strip || !state) return;

    var now  = step();                                    /* the rung their next piece sits on */
    var kept = Number(state.redeemed) || 0;               /* pieces they actually kept, ever */
    var lap  = Number(state.lap) || 0;
    var have = (Number(state.balance) || 0) > 0;
    var free = freeChoice();

    /* How many of THIS lap's rungs they actually took a piece on. The rung comes from orders now,
       but green still means "you kept one", so the two can legitimately disagree: someone who
       ordered four times and never picked anything sits on rung four with nothing green behind
       them. That is the truth and it should look like it.
       ⚠ Dom, 10 Sep: his ladder read ring "yours" and chain "yours" when he had never checked out
       with a free piece in his life. Never paint green off anything but real, kept redemptions. */
    var keptThisLap = Math.max(0, Math.min(kept - (lap * STEPS.length), STEPS.length));

    var stamp = now + '|' + kept + '|' + have + '|' + lap + '|' + (free ? 'f' : '-');
    if (strip.getAttribute('data-dp-ladder') === stamp) return;   /* idempotent — observers repaint */

    /* The three states, plain (Dom, 10 Sep — "had it" told him nothing about what to DO):
         green + "yours"   a piece he actually kept
         red   + "choose"  the one he can pick right now
         grey  + "waiting" not yet
       "redeemed" is the obvious word for the green one and is BANNED — it is on the copy deck's
       never-list along with unlock, points and claim. "yours" says the same thing warmly. */
    var html = '';
    for (var i = 0; i < LADDER.length; i++){
      var got  = i < keptThisLap;
      var here = i === now;
      var cls  = 'step' + (got ? ' done dp-got' : (here ? ' done dp-now' : ''));
      var note = got ? 'yours' : (here ? (have ? 'choose' : 'next up') : 'waiting');
      html += '<div class="' + cls + '"><span class="dot"></span>' + LADDER[i] +
              '<i style="display:block;font-style:normal;font-size:8.5px;opacity:.72;' +
              'margin-top:2px">' + note + '</i>' +
              '</div>';
    }
    strip.innerHTML = html;
    strip.setAttribute('data-dp-ladder', stamp);

    /* NO SENTENCE UNDERNEATH. There was one and Dom killed it on sight — "pretty bad, I'd just
       get rid of it". The ladder already reads ring / chain / pendant with a word under each, so
       a line restating that in worse words was noise. Anything left from the old build is taken
       back out here so it cannot linger in a cached page. */
    var stale = document.querySelector('#p-rewards [data-dp-ladderline]');
    if (stale && stale.parentNode) stale.parentNode.removeChild(stale);
  }

  /* ---------- boot ---------- */
  async function load(){
    var cid = customerId();
    if (!cid) return;
    try{
      var r = await (await fetch(API + '/api/credits?cid=' + encodeURIComponent(cid),
                                 { credentials:'omit' })).json();
      if (r && r.ok) state = r;
    }catch(e){}
  }

  function wrapOpen(){
    if (typeof window.dpOpenPicker !== 'function' || window.dpOpenPicker.__dpLadder) return false;
    var orig = window.dpOpenPicker;
    var wrapped = function(){
      /* repoint BEFORE the picker paints, or they see the last step's grid for a frame */
      try{ pointPicker(); titlePicker(); }catch(e){}
      return orig.apply(this, arguments);
    };
    wrapped.__dpLadder = true;
    window.dpOpenPicker = wrapped;
    return true;
  }

  async function boot(){
    if (!document.getElementById('p-rewards')) return;
    await load();
    paintLadder();

    /* Charlie's domno-portal.js may not have run yet, and the drawer repaints on navigation, so
       poll rather than assuming one pass — the same pattern credits.js uses. */
    var n = 0, iv = setInterval(function(){
      n++;
      wrapOpen();
      if (state) paintLadder();
      if (n > 300) clearInterval(iv);
    }, 400);

    ['on:cart:change','on:cart:after-merge','on:line-item:change'].forEach(function(nm){
      document.addEventListener(nm, function(){ load().then(paintLadder); });
    });
  }

  window.dpLadderRefresh = function(){ return load().then(function(){ paintLadder(); pointPicker(); }); };
  window.dpLadderStep = function(){ return state ? activeSet() : STEPS[0]; };
  window.dpLadderFree = function(){ return freeChoice(); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();